export const sortByDate = (a, b) => {
    return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
}